<!-- Bouton Retour à l’accueil -->
<dsd-link-action variant="return" class="dsd-mb-md">
  <a [href]="urlAccueil"
    ><span class="dsd-sr-only">{{ 'caad.button.horsEcran.allerA' | translate }}&nbsp;</span
    >{{ 'caad.button.retouraccueil' | translate }}</a
  >
</dsd-link-action>
